module.exports = __webpack_public_path__ + "static/media/slide03_image.490d2ff5.png";